import type {
  RouteIndication,
  RouteSegment,
  RouteStep,
} from "../navigation/types";

export enum RouteType {
  CHOOSE_SHORTEST = "CHOOSE_SHORTEST",
  ONLY_ACCESSIBLE = "ONLY_ACCESSIBLE",
  ONLY_NOT_ACCESSIBLE_FLOOR_CHANGES = "ONLY_NOT_ACCESSIBLE_FLOOR_CHANGES",
}

export enum DIRECTIONS_ERROR_CODES {
  untraceable_route,
  no_valid_bus_pois_nearby,
  origin_same_as_destination,
  no_navigation_between_buildings,
  no_location,
  outdoor_oob_location,
}

export enum RouteComputationStatus {
  CALCULATING = "calculating",
  FINISHED = "finished",
}

export enum FormSelectorMode {
  from,
  to,
  null,
}

export interface DirectionsRoute {
  id: number;
  segments: RouteSegment[];
  steps: RouteStep[];
  indications: RouteIndication[];
  origin: number;
  destination: number;
  currentStep?: RouteStep;
  tags: RouteType[];
}

export interface DirectionsSearch {
  enabled: boolean;
  showingMap: boolean;
  selectorNameSelected: FormSelectorMode;
}

export interface SliceProps {
  routes: DirectionsRoute[] | null;
  routeComputationStatus: RouteComputationStatus;
  selectedRouteId: number | null;
  selectedRouteType: RouteType | null;
  search: DirectionsSearch;
  errors: Array<DIRECTIONS_ERROR_CODES>;
  isAutoPlaying: boolean;
}
